<style lang="stylus">
    .pageworks-empty-container
        min-height calc(100% - 64px)
        position relative
    .pageworks-container
        position relative
        margin-top 60px
    .pageworks-filter
        position relative
        z-index 1
        padding 24px 0 24px 16px
        // background #FFFFFF
        // box-shadow 0px 0px 2px rgba(27, 64, 81, 0.2)
        // border-radius 5px
        ul
            display flex
            li
                margin 0 16px
                user-select none
                cursor pointer
                position relative
                &:first-child
                    margin-left 6px
                p
                    font-size 12px
                    color #000
                &.active
                    p
                        font-weight 700
                    &:before
                            position absolute
                            content ''
                            left -6px
                            top 0
                            bottom 0
                            margin auto
                            display block
                            width 2px
                            height 14px
                            background-color #017FFF

    .pageworks-empty
        display flex
        justify-content center
        align-items center
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        z-index 0
        .empty-box
            display flex
            justify-content center
            flex-wrap wrap
            width 250px
            .empty-svg
                width 241px
                height 117px
            .empty-svg_viewer
                width 224px
                height 109px
            .empty-text
                font-size 14px
                color #000
                text-align center
                margin-top 20px
                a
                    color var(--themeColor)
                    &:hover,&:link,&:active,&:visited
                        text-decoration underline

    .pageworks-page
        display flex
        justify-content space-around
        margin-top 15px
        color #626262 !important

        .el-pagination
            button
                background none !important

        .el-pager li
            background none
    .dark-theme__workbench
        .pageworks-filter
            ul
                li
                    p
                        color #fff
        .pageworks-empty
            .empty-box
                .empty-text
                    color #fff
</style>
<template>
    <div :class="{ 'pageworks-container': works.length > 0 && isfixed, 'pageworks-empty-container': works.length <= 0 }">
        <div class="pageworks-filter" v-if="!isViewer">
            <ul>
                <li v-for="item in filterData" :key="item.id" :class="{ active: item.id == activeFilter }" @click="changeFilter(item)">
                    <p>{{ item.label }}</p>
                </li>
            </ul>
        </div>

        <div ref="con" class="page-waterfall" v-show="works.length != 0" :style="{ height: `${fitHeight}px` }">
            <waterfall ref="works" :workType="filterType" :works="works" />
        </div>

        <div class="pageworks-empty" v-if="works.length == 0">
            <div class="empty-box" v-if="isViewer">
                <iconSymbol class="empty-svg_viewer" name="empty_works_viewer" />
                <p class="empty-text">{{ $t("nodata") }}</p>
            </div>
            <div class="empty-box" v-else>
                <iconSymbol class="empty-svg" name="empty_works" />
                <p class="empty-text">{{ $t("nodata") }}</p>
            </div>
        </div>

        <div class="pageworks-page" v-show="works.length > 0 && worksTotal > pageCount && isViewer">
            <Page :total="worksTotal" :page-size="pageCount" @on-change="pageChanged" size="small" />
        </div>
        <!-- <div class="pageworks-page" v-show="works.length > 0 && isViewer">
            <client-only>
                <Pagination
                    layout="prev, pager, next, jumper"
                    :current-page="Number(worksCurrent)"
                    :total="worksTotal"
                    :page-size="pageCount"
                    :hide-on-single-page="true"
                    @current-change="pageChanged"
                />
            </client-only>
        </div> -->
    </div>
</template>
<script>
    import waterfall from "./mixins/waterfall.js";
    export default {
        name: "PageWorks",
        data() {
            return {
                filterData: [
                    {
                        id: 0,
                        label: `${this.$t("all")}`,
                        value: "ALL",
                    },
                    {
                        id: 1,
                        label: `${this.$t("pass")}`,
                        value: "PASS",
                    },
                    {
                        id: 2,
                        label: `${this.$t("pending")}`,
                        value: "PENDING",
                    },
                ],
                activeFilter: 0,
                works: [],
                waterfallType: "works",
                filterType: "ALL",
                fitHeight: 0,
            };
        },
        mixins: [waterfall],
        components: {
            // Pagination,
        },
        props: {
            isfixed: {
                type: Boolean,
                require: false,
                default: false,
            },
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
            pageCount() {
                return this.$store.state.userPage.pageCount;
            },
            worksTotal() {
                return this.$store.state.userPage.worksTotal;
            },
            worksCurrent() {
                return this.$store.state.userPage.worksCurrent;
            },
        },
        methods: {
            changeFilter(obj) {
                console.log("filter:", obj);
                this.activeFilter = obj.id;
                this.filterType = obj.value;
                this.getWork(obj.value);
            },
            toTop() {
                let targetDom = document.children[0];
                targetDom.scroll = (e) => {
                    e.preventDefault();
                };
                const scrollToTop = () => {
                    const scrollTop = targetDom.scrollTop;
                    if (scrollTop > 0) {
                        window["scrollTopID"] = window.requestAnimationFrame(scrollToTop);
                        targetDom.scrollTo(0, scrollTop - scrollTop / 8);
                    } else {
                        window.cancelAnimationFrame(window["scrollTopID"]);
                        window["scrollTopID"] = null;
                        targetDom.scroll = null;
                    }
                };
                window["scrollTopID"] = window.requestAnimationFrame(scrollToTop);
            },
            pageChanged(page) {
                this.works = [];
                this.$store.dispatch("userPage/getIntervieweePublishByPage", page).then((e) => {
                    this.works = this.$store.state.userPage.storeWorks;
                    this.updateWaterfall({ works: this.works });
                });
                this.toTop();
            },
            getWork(status = "ALL") {
                this.$edApi
                    .getSelfWorks({
                        id: this.userInfo.user_id,
                        token: this.userInfo.token,
                        status,
                        platform: this.$store.state.publicStore.runPlatform,
                    })
                    .then((e) => {
                        this.works = [];
                        this.$store.commit("userPage/setState", {
                            type: "storeWorks",
                            data: e.data,
                        });
                        this.$store.commit("userPage/setState", {
                            type: "worksTotal",
                            data: e.data.length,
                        });
                        this.updateWaterfall({ works: this.$store.state.userPage.storeWorks });
                    });
            },
            resizeFit() {
                const topBar = 60;
                const menu = 64;
                const margin = 24;
                const pager = 24;
                let winH = window.innerHeight;
                this.fitHeight = winH - topBar - menu - margin - pager - margin;
            },
        },
        created() {
            if (this.userInfo.islogin) {
                if (!this.isViewer) {
                    this.getWork();
                } else {
                    this.works = this.$store.state.userPage.storeWorks;
                }
            } else {
                this.works = this.$store.state.userPage.storeWorks;
                this.$bus.$on("loginSucc", () => {
                    if (!this.isViewer) {
                        this.getWork();
                    }
                });
            }
            this.resizeFit();
            window.addEventListener("resize", this.resizeFit);
        },
        beforeDestroy() {
            this.$bus.$off("loginSucc");
            window.removeEventListener("resize", this.resizeFit);
        },
    };
</script>
<i18n>
{
  "zh": {
    "nodata": "这里什么都没有哦",
    "all": "所有作品",
    "pending": "审核中",
    "pass": "通过审核"
  },
  "en": {
    "nodata": "It is empty",
    "all": "All works",
    "pending": "under review",
    "pass": "Approved"
  },
  "kr": {
    "nodata": "아직 아무것도 없네요~",
    "all": "모든 작품",
    "pending": "심사중",
    "pass": "심사 통과!"
  },
  "tw": {
    "nodata": "這裡什麼都沒有哦",
    "all": "所有作品",
    "pending": "審核中",
    "pass": "通過審核"
  },
  "jp": {
    "nodata": "まだファイルはありません",
    "all": "すべて",
    "pending": "レビュー中",
    "pass": "レビューは完了しました"
  },
  "id": {
    "nodata": "Kosong",
    "all": "Semua tugas",
    "pending": "sedang ditinjau",
    "pass": "Disetujui"
  }
}
</i18n>
